
import Vue from 'vue'
import '../index.less'

export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
    }
  },
  props:{
    objectsList:{
      type: Array,
      default: () => ([])
    },
    detail:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    detail:{
      handler(){
        this.form.resetFields()
      },
      immediate: true,
      deep: true
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSave(){
      this.form.validateFields((err,values) => {
        if (!err) {
          const objdct = this.objectsList.find(res => res.applicationObjectCode === values.applicationObject)
          values.applicationObject = objdct.applicationObject
          values.applicationObjectCode = objdct.applicationObjectCode
          values.id = this.detail.id
          this.$emit('saveAll',values)
        }
      });
    },
    chaneValue(value){
      this.$emit('change',value)
    }
  }
})
